import { createContext } from "react";
import { create } from "zustand";
export var SectionEventContext = createContext(undefined);
export var DEFAULT_STORE_KEY = "SCENE_VIEWER";
export var useSectionViewerStore = create(function () { return ({
    currentSection: {},
    currentIndex: {},
    action: {},
}); });
